
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gKYCSkrYRztC0deuEO1FZSKXrV6XCZqdXytUo4VZ0uWAMeta } from "/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index2hGV8jVfgkXpnHtxLUlY_45wfWZQo8fR2pA7YrFM68vvoMeta } from "/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchXCyMNTZUYG91458ehDsyjPGhYtaqwbkI0m1CpB2xWgYMeta } from "/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexjqixrwv2zrv3jOHFWC4fCE1gYFONkUclDIU28YDKassMeta } from "/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93c9EP2Qq4xuNzxzW9PFPznfhyhaF1uMW05x5OkX9ivjIMeta } from "/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexDbKPgE5VRgz4HewPg82qdkxDXhkVnEumiJ1QF15XOQQMeta } from "/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93p4DEl0rMNhDfyiH13Xhb_oePQQF6vgGzJiXHM_45xP22EMeta } from "/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexwhC6xFnbcFHjbUogAlCAdocWNeT5YTcM31KTfNCOWE4Meta } from "/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93GClp2dLgWHFRFKPqR_n3tidINMraHDKKgdPpk6ksPNMMeta } from "/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexLzgAoNc2TKzN_45haeV6yFtm6pHTg8G_vRpJ5Uc2fnGoIMeta } from "/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index2B4701bvaQHGFaZsY_45Xu6LAzh_fDlry7F_DF01jWOV8Meta } from "/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexDbKPgE5VRgz4HewPg82qdkxDXhkVnEumiJ1QF15XOQQMeta || {},
    component: () => import("/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexwhC6xFnbcFHjbUogAlCAdocWNeT5YTcM31KTfNCOWE4Meta || {},
    component: () => import("/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexLzgAoNc2TKzN_45haeV6yFtm6pHTg8G_vRpJ5Uc2fnGoIMeta || {},
    component: () => import("/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index2B4701bvaQHGFaZsY_45Xu6LAzh_fDlry7F_DF01jWOV8Meta || {},
    component: () => import("/codebuild/output/src2226915626/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]